import { render } from "./DownloadPage.vue?vue&type=template&id=d44fb564&scoped=true"
import script from "./DownloadPage.vue?vue&type=script&lang=js"
export * from "./DownloadPage.vue?vue&type=script&lang=js"

import exportComponent from "/lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d44fb564"]])

export default __exports__